import React from 'react';

const ReviewsSection = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: ReviewsSection is not implemented yet.');
  }, []);
  return (
    <>
  { /*ReviewsSection */} 
 </>
  );
};

export default ReviewsSection;
